import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTheme } from 'styled-components';
import { getProductTypeLabel, getFundsCategoriesPath } from '@finect/front-resources/Products';
import { Section } from '../../Section';
import { Category } from '../../Products/Categories';
export var FundsCategories = function FundsCategories(_ref) {
  var productType = _ref.productType,
    categories = _ref.categories;
  var theme = useTheme();
  var items = categories.slice(0, 20);
  return React.createElement(Section, {
    bottomMargin: true,
    title: "Categor\xEDas de ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase')),
    subtitle: "Consulta las distintas categor\xEDas que tenemos en ".concat(getProductTypeLabel(productType, 'plural', 'lowercase')),
    link: {
      href: getFundsCategoriesPath(theme, productType),
      text: "Ver ".concat(categories.length, " categor\xEDas m\xE1s")
    }
  }, React.createElement("div", {
    style: {
      marginBottom: '0.8rem'
    }
  }, items.map(function (category) {
    return React.createElement(Category, {
      key: category.id,
      category: category,
      productType: productType
    });
  })));
};